export function getInitialValues(variant: 'default' | 'zooming') {
  if (variant === 'default') {
    return {
      x: 0,
      y: 0,
      size: 300,
    };
  }
  return {
    x: -40,
    y: -40,
    size: 300,
  };
}

export function generateSnippet(x: number, y: number, size: number) {
  return `
<svg
  width="300"
  height="300"
  viewBox="${x} ${y} ${size} ${size}"
>
  <rect
    x="0"
    y="0"
    width="200"
    height="200"
  />
</svg>`;
}
